module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2 step-body clinic-leave-wrapper"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('message.leave.title')))]), _vm._v(" "), _c('button', {
    staticClass: "add-leave btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.newLeave($event)
      }
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t('action_message.add')))]), _vm._v(" "), _c('div', {
    staticClass: "btn-group toggle_view_group",
    attrs: {
      "role": "group",
      "aria-label": ""
    }
  }, [(!_vm.showCalendar) ? _c('button', {
    staticClass: "btn btn-sq-border",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCalendarView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  }), _vm._v(" " + _vm._s(_vm.$t('message.leave.calendar')))]) : _vm._e(), _vm._v(" "), (_vm.showCalendar) ? _c('button', {
    staticClass: "btn btn-sq-border",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showListView()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-list"
  }), _vm._v(" " + _vm._s(_vm.$t('message.leave.list')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('bs-input', {
    attrs: {
      "placeholder": _vm.$t('message.leave.search_doctor')
    },
    model: {
      value: (_vm.doctorSearchQ),
      callback: function($$v) {
        _vm.doctorSearchQ = $$v
      },
      expression: "doctorSearchQ"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCalendar),
      expression: "!showCalendar"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [(!_vm.$ismobile()) ? _c('div', [_c('table', {
    staticClass: "table table-bordered table-responsive"
  }, [_c('thead', {
    attrs: {
      "width": "100%"
    }
  }, [(_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.date')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.name')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "30%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.remark')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  })]) : _c('tr', [_c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.date')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "65%"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.leave.remark')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    attrs: {
      "width": "10%"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.displayLeaveList.data), function(leave) {
    return _c('tr', {
      key: leave.id
    }, [_c('td', {
      staticClass: "text-center"
    }, [(leave.all_day) ? _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("formatDateFull")(leave.start_time)))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateFull")(leave.end_time)))])]) : _c('div', [_c('span', [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(leave.start_time)))]), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateTimeFull")(leave.end_time)))])])]), _vm._v(" "), (_vm.$guser.isClinic() || _vm.$guser.isClinicMulti()) ? _c('td', [_c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(leave.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(leave)))])]), _vm._v(" "), _c('small', {
      staticClass: "text-one-ellipsis"
    }, [_vm._v(_vm._s(_vm.getDoctorSpecialty(leave)))])]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-justify"
    }, [_c('span', [_vm._v(_vm._s(_vm.viewContent(leave.description, !leave.showMoreContent)))]), _vm._v(" "), (leave.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(leave)
        }
      }
    }, [_vm._v(_vm._s(leave.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.more')))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o",
      on: {
        "click": function($event) {
          _vm.editLeave(leave)
        }
      }
    }, [_c('small', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])])
  }), _vm._v(" "), (_vm.loaded && _vm.displayLeaveList.data.length === 0) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('message.leave.no_leave')))])])]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('tr', [_c('td', {
    staticClass: "alert alert-warning",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)])]) : _vm._e()], 2)])]) : _c('div', [_c('div', {
    staticClass: "leave-list-container"
  }, _vm._l((_vm.displayLeaveList.data), function(leave) {
    return _c('div', {
      key: leave.id,
      staticClass: "card leave-list-content"
    }, [_c('div', {
      staticClass: "card-header"
    }, [_c('div', {
      staticClass: "row"
    }, [(leave.all_day) ? _c('span', {
      staticClass: "col-12 app-id"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.leave.date')) + ": " + _vm._s(_vm._f("formatDateFull")(leave.start_time)) + " - " + _vm._s(_vm._f("formatDateFull")(leave.end_time)) + "\n                  ")]) : _c('span', {
      staticClass: "col-12 app-id"
    }, [_vm._v("\n                    " + _vm._s(_vm.$t('message.leave.date')) + ": " + _vm._s(_vm._f("formatDateTimeFull")(leave.start_time)) + " - " + _vm._s(_vm._f("formatDateTimeFull")(leave.end_time)) + "\n                  ")])])]), _vm._v(" "), _c('div', {
      staticClass: "card-block"
    }, [_c('h5', {
      staticClass: "app-doctor"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDoctor(leave.doctor_id)
        }
      }
    }, [_vm._v(_vm._s(_vm.getDoctorName(leave)))])]), _vm._v(" "), _c('span', {
      staticClass: "app-remark"
    }, [_vm._v(_vm._s(_vm.viewContent(leave.description, !leave.showMoreContent)))]), _vm._v(" "), (leave.moreContentEnable) ? _c('a', {
      staticClass: "view-more-btn",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.toggleMoreContent(leave)
        }
      }
    }, [_vm._v(_vm._s(leave.showMoreContent ? _vm.$t('action_message.close') : _vm.$t('action_message.more')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.editLeave(leave)
        }
      }
    }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t('action_message.edit')))])])])])])
  })), _vm._v(" "), (_vm.loaded && _vm.displayLeaveList.data.length === 0) ? _c('h6', {
    staticClass: "text-center alert alert-warning"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.leave.no_leave')) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "btn btn-sm"
  }, [_c('sync-loader', {
    attrs: {
      "size": "10px"
    }
  })], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCalendar),
      expression: "showCalendar"
    }],
    staticClass: "row"
  }, [_vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    attrs: {
      "id": "leaveCalendar"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f8db12c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/clinic/leave/LeaveList.vue
// module id = 1031
// module chunks = 1